module.exports = __webpack_public_path__ + "static/img/n_phone.c7facb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/n_phone.png
// module id = ZhTB
// module chunks = 0